import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevron = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.32 6.277a1.211 1.211 0 0 1 1.542 0l5.819 5.053c.426.37.426.97 0 1.34l-5.819 5.053a1.21 1.21 0 0 1-1.542 0 .862.862 0 0 1 0-1.34L13.366 12 8.32 7.617a.862.862 0 0 1 0-1.34Z",
		clipRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgChevron);
export default ForwardRef;
